export function objectUnzip(object) {
    const entries = Object.entries(object);
    const keys = entries.map(([key, _]) => key);
    const values = entries.map(([_, value]) => value);
    return [keys, values];
}
export function objectZip(keys, values) {
    const ret = {};
    keys.forEach((key, index) => {
        ret[key] = values[index];
    });
    return ret;
}
